import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
export var IBannerData;
(function(IBannerData) {
    IBannerData.build = function(partial) {
        return _object_spread({
            size: 0,
            row: 0,
            column: 0
        }, partial !== null && partial !== void 0 ? partial : {});
    };
})(IBannerData || (IBannerData = {}));
export var sortBanner = function(bannerA, bannerB) {
    return bannerA.row - bannerB.row || bannerA.column - bannerB.column;
};
export var withBanner = function(items, itemsPerRow, bannerData) {
    var itemsWithFakeTiles = _to_consumable_array(items);
    var fakeTile = {
        fake: true
    };
    var sortedBannerData = bannerData.sort(sortBanner);
    sortedBannerData.forEach(function(banner) {
        if (banner.renderAsModal) {
            return;
        }
        var rowToInsert = banner.row - 1;
        var columnToInsert = banner.column - 1;
        var indexToInsert = rowToInsert * itemsPerRow + columnToInsert;
        for(var i = 0; i < banner.size; i++){
            itemsWithFakeTiles.splice(indexToInsert, 0, fakeTile);
        }
    });
    return itemsWithFakeTiles;
};
